// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Inter-Variable.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Inter-Variable.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/Inter-Variable.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Inter Variable";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2-variations"),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff-variations"),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
    font-weight: 100 900;
    font-stretch: 50% 150%;
    font-display: swap;
}

/* VARIABLES
====================================================== */

:root { 
    --c-danger-red: hsl(357 53% 60%);

    --c-accent-red: hsl(4, 85%, 63%);
    --c-accent-orange: hsl(40, 100%, 49%);
    --c-accent-lime: hsl(84, 54%, 46%);
    --c-accent-blue: hsl(216, 81%, 60%); 

    --c-grey-100: hsl(0 4% 88%); /* 13.1 E2DFDF*/
    --c-grey-200: hsl(0 4% 77%); /* 9.9 */
    --c-grey-300: hsl(0 4% 64%); /* 6.4 */
    --c-grey-400: hsl(0 2% 52%); /* 4.6 #878282*/
    --c-grey-500: hsl(0 2% 40%); /* 2.97 */
    --c-grey-600: hsl(0 2% 26%); /* #444141 */
    --c-grey-700: hsl(0 2% 18%); /* #444141 */


    --c-bg-primary: hsl(0 0% 7%);
    --c-bg-secondary: hsl(0 0% 9%);
    --c-fg-primary: hsl(0 2% 11%);
    --c-fg-secondary: hsl(0 2% 13%);


    --c-text-default: var(--c-grey-100);
    --c-text-muted: var(--c-grey-200);
    --c-text-faint: var(--c-grey-500);
}

/* NORMALISE
====================================================== */

*, *:before, *:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    max-width: 100%;
}

a {
    text-decoration: none;
    color: inherit;
}

ul, ol, li {
    list-style: none;
}

input, textarea, button, select {
    font: inherit;
    color: inherit;
    background: none;
    border: none;
}

button {
    cursor: pointer;
}

hr {
    border: none;
}

dialog {
    font: inherit;
    color: inherit;
    border: none;
}

/* BASE
====================================================== */

html, body {
    height: 100%;
    font-family: "Inter Variable";
    font-weight: 350;
    color: var(--c-text-default);
    background-color: var(--c-bg-primary);
}

.shell {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.container {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    position: relative;
    display: grid;
    grid-template-columns: 0.65fr 3fr minmax(328px, 1fr);
    grid-template-areas: 
    "sidebar tasks form";
}

dialog {
    background-color: var(--c-bg-secondary);
}

/* SIDEBAR
====================================================== */

.sidebar {
    grid-area: sidebar;
    min-width: 200px;
    display: grid;
    grid-auto-rows: min-content;
    gap: 40px;
    padding: 20px 20px;
    border-right: 1px solid var(--c-grey-700);
    background-color: var(--c-bg-primary);
}

ul {
    display: grid;
    gap: 4px; 
}

.sidebar-item {
    display: flex;
    align-items: center;
    padding: 8px;
    font-size: 0.875rem;
    color: var(--c-text-muted);
}

.sidebar-item:hover,
.sidebar-item:has(.sidebar-more-btn.menu-open):not(.active) {
    border-radius: 6px;
    background-color: var(--c-fg-primary);
    cursor: pointer;
}

.sidebar-item.active {
    border-radius: 6px;
    background-color: var(--c-grey-600);
    color: var(--c-grey-100);
}

.sidebar-icon {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    stroke-width: 1.5;
    color: var(--c-grey-400);
}

.sidebar-projects {
    display: grid;
    gap: 12px;
}

.sidebar-projects h3 {
    font-size: 0.8125rem;
    color: var(--c-text-faint);
}

.sidebar-label {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sidebar-end-slot{
    margin-left: auto;
    display: grid;
    grid-template-areas: "stack";
    align-items: center;
    justify-items: center;
    min-width: 20px;
}

.sidebar-count,
.sidebar-more-btn {
    grid-area: stack;
}

.sidebar-count {
    font-size: 0.75rem;
    color: var(--c-grey-200);
}

.sidebar-more-btn {
    opacity: 0;
    padding: 2px 8px;
    border-radius: 4px;
}

.sidebar-item:has(.sidebar-more-btn):hover .sidebar-count,
.sidebar-item:has(.sidebar-more-btn.menu-open) .sidebar-count {
    opacity: 0;
}

.sidebar-item:hover .sidebar-more-btn,
.sidebar-more-btn.menu-open {
    opacity: 1;
}

.sidebar-more-btn:hover,
.sidebar-more-btn.menu-open {
    background-color: color-mix(in hsl shorter hue, var(--c-grey-600), black 12%);
}

.context-menu {
    position: fixed;
    background: var(--c-fg-secondary);
    padding: 4px;
    border-radius: 6px;
    list-style: none;
    z-index: 1000;
}

.context-menu.hidden {
    display: none;
}

.context-menu button {
    display: block;
    width: 100%;
    text-align: left;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 0.8125rem;
}

.context-menu button:hover {
    background: var(--c-grey-600);
}

/* TOPBAR (sidebar toggle)
====================================================== */

.topbar {
    flex-shrink: 0;
    display: none;
    width: 100%;
    padding: 14px 20px;
    border-bottom: 1px solid var(--c-grey-700);
    background-color: var(--c-bg-primary);
}

.sidebar-toggle-btn {
    display: flex;
    align-items: center;
    padding: 4px;
}

.sidebar-toggle-btn:hover {
    background-color: var(--c-grey-700);
}

.menu-icon {
    width: 24px;
    height: 24px;
    color: var(--c-grey-100);
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
}

/* MAIN
====================================================== */

main {
    grid-area: tasks;
    display: grid;
    grid-template-rows: auto 1fr;
    gap: 20px;
    padding: 20px 20px;
    background-color: var(--c-bg-secondary);
}

main header {
    display: grid;
    grid-template: auto auto / 1fr auto;
    gap: 8px;
}

main header h1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 26px;
    font-weight: 500;

}
main header p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.5;
    min-height: calc(1.5em * 3);
    color: var(--c-grey-400);
}

main header button {
    grid-column: 2;
    grid-row: 1;
    width: 96px;
    white-space: nowrap;
}

.task-list-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.task-list-header {
    display: grid;
    grid-template: auto / 0.06fr 1fr 0.35fr 0.21fr 0.17fr 0.2fr;
    gap: 20px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--c-grey-600);
    font-size: 0.875rem;
    color: var(--c-grey-400);
}

.header-checkbox {
    justify-self: center;
    width: 20px;
    height: 20px;
    margin-left: 10px;
}

.header-project {
    visibility: visible;
}

.task-list-header:not(.show-project) .header-project {
    visibility: hidden;
}

/* TASKS LIST
====================================================== */

.card-task {
    display: grid;
    grid-template-columns: 0.06fr 1fr 0.35fr 0.21fr 0.17fr 0.2fr;
    align-items: center;
    gap: 20px;
    min-width: 600px;
    padding: 14px 0px;
    border-bottom: 1px solid var(--c-grey-700);
}

.card-task:hover {
    background-color: var(--c-fg-primary);
    cursor: pointer;
}

.task-checkbox {
    justify-self: center;
    position: relative;
    box-sizing: border-box;
    appearance: none;
    margin-left: 10px;
    padding: 0;
    width: 20px;
    height: 20px;
    border: 1px solid var(--c-grey-400);
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.task-checkbox:hover {
    border-color: var(--c-grey-300);
}

.task-checkbox:checked {
    background-color: var(--c-accent-lime);
    border-color: var(--c-accent-lime);
}

.task-checkbox:checked::after {
    content: "";
    position: absolute;
    left: 5px;
    top: 1px;
    width: 8px;
    height: 12px;
    border: 1px solid var(--c-grey-600);
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
}

.card-task h2 {
    overflow-wrap: break-word;
    min-width: 0;
    hyphens: auto;
    padding: 4px 0px;
    font-size: 1rem;
    font-weight: 350;
    line-height: 1.6;
}

.card-task h2.done {
    text-decoration: line-through;
    color: var(--c-grey-400);
}

.card-task span {
    font-size: 0.875rem;
    color: var(--c-grey-400);
}

.hidden-tag {
    visibility: hidden;
}

.card-task span[data-priority="low"] {
    color: var(--c-accent-lime);
}

.card-task span[data-priority="medium"] {
    color: var(--c-accent-orange);
}

.card-task span[data-priority="high"] {
    color: var(--c-accent-red); 
}

.card-task span[data-status="overdue"] {
    color: var(--c-accent-red); 
}

.card-task span[data-status="today"] {
    color: var(--c-accent-orange);
}

.card-task span[data-status="soon"] {
    color: var(--c-accent-blue); 
}

.quick-add {
    display: grid;
}

.card-task.selected {
  background: var(--c-grey-700);
  border-radius: 6px;
}


/* MODALS/FORMS/INPUTS GENERAL
====================================================== */

.modal {
    position: fixed;
    margin: auto;
    border-radius: 20px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.modal::backdrop {
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(0.3px);
}

.form-modal,
.delete-modal {
    width: 400px;
    padding: 20px;
    background-color: var(--c-fg-primary)
}

.form-wrapper,
.modal-wrapper {
    display: grid;
    gap: 16px;
}

h2 {
    font-size: 1rem;
}

label {
    font-size: 0.875rem;
    color: var(--c-grey-400);
}

.form-content {
    display: grid;
    flex: 1;
    gap: 6px;
}

input, textarea, select {
    appearance: base-select;
    padding: 6px 10px;
    border: 1px solid var(--c-grey-700);
    border-radius: 6px;
    background-color: var(--c-fg-secondary);
    transition: border 0.15s ease-in-out;
    font-weight: 300;
}

textarea {
    resize: vertical;
    min-height: 60px;
    field-sizing: content;
    overflow-y: auto;
}

#edit-task-title {
    resize: none;
    min-height: auto;
}

textarea::placeholder {
    color: var(--c-grey-600);
}

input:hover, textarea:hover, select:hover {
    border: 1px solid var(--c-grey-600);
}

input:focus, textarea:focus, select:focus {
    outline: none;
    border: 1px solid var(--c-grey-500)
}

.form-actions,
.modal-actions {
    display: flex;
    justify-content: end;
    gap: 12px;
    margin-top: 28px;
}

.task-title-input {
    min-width: 400px;
    min-height: auto;
}


/* PROJECTFORM
====================================================== */

.color-picker {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
}

.color-swatch {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    outline: 3px solid var(--c-grey-600);
    outline-offset: -5px;
    outline-color: transparent;
    transition: outline-color 0.15s ease;
}

.color-swatch.selected {
    outline-color: var(--c-grey-600);
}

/* TASKFORM (+ASIDE)
====================================================== */

.task-form {
    grid-area: form;
    height: 100%;
    padding: 20px 20px;
    border-left: 1px solid var(--c-grey-700);
    background-color: var(--c-bg-primary);
}

.hidden {
    display: none;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-row {
    display: flex;
    gap: 12px;
}

#task-due,
#edit-task-due {
    padding-right: 6px;
}

#task-due::-webkit-calendar-picker-indicator,
#edit-task-due::-webkit-calendar-picker-indicator {
    filter: invert(1) brightness(0.7); /* slightly softened white, adjust to taste */
    cursor: pointer;
}

select[data-priority="low"] {   
    color: var(--c-accent-lime);
}

select[data-priority="medium"] { 
    color: var(--c-accent-orange);
}

select[data-priority="high"] { 
    color: var(--c-accent-red); 
}

option[value="low"] { color: var(--c-accent-lime); }
option[value="medium"] { color: var(--c-accent-orange); }
option[value="high"] { color: var(--c-accent-red); }


.checklist-items {
    display: grid;
    gap: 4px;
    padding: 0px 6px;
    margin-bottom: 8px;
}

.checklist-item {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 6px;
    align-items: center;
}

.checklist-item-checkbox {
    justify-self: center;
    position: relative;
    box-sizing: border-box;
    appearance: none;
    padding: 0;
    width: 16px;
    height: 16px;
    border: 1px solid var(--c-grey-400);
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.checklist-item-checkbox:hover {
    border-color: var(--c-grey-300);
}

.checklist-item-checkbox:checked {
    background-color: var(--c-accent-lime);
    border-color: var(--c-accent-lime);
}

.checklist-item-checkbox:checked::after {
    content: "";
    position: absolute;
    left: 4.5px;
    top: 1px;
    width: 6px;
    height: 10px;
    border: 1px solid var(--c-grey-600);
    border-width: 0px 2px 2px 0px;
    transform: rotate(45deg);
}

.checklist-item-text {
    border: none;
    border-bottom: 1px solid var(--c-grey-700);
    border-radius: 0;
    background-color: transparent;
}

.checklist-item-text.done {
    text-decoration: line-through;
    color: var(--c-grey-400);
}

.checklist-item-text:hover {
    border: none;
    border-bottom: 1px solid var(--c-grey-600);
}

.checklist-item-text:focus {
    outline: none;
    border: none;
    border-bottom: 1px solid var(--c-grey-500)
}

.checklist-item-text::placeholder {
    color: var(--c-grey-500);
}

.form-sidebar .form-actions {
    margin-top: 40px;
}

#edit-task-delete {
    margin-right: auto;
}

/* ACTION BUTTONS 
====================================================== */

.btn {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 0.875rem;
    transition: transform 0.15s ease;
}

.btn:active {
    transform: scale(0.97);
}

.btn-primary {
    background-color: var(--c-grey-100);
    color: var(--c-grey-600);
    font-weight: 500;
}

.btn-primary:hover {
    background-color: color-mix(in hsl shorter hue, var(--c-grey-100), black 8%);;
}

.btn-primary.color {
    background-color: var(--c-accent-lime);
}

.btn-primary.color:hover {
    background-color: color-mix(in hsl shorter hue, var(--c-accent-lime), black 8%);
}

.btn-neutral {
    background-color: var(--c-grey-500);
    color: var(--c-grey-100);
}

.btn-neutral:hover {
    background-color: color-mix(in hsl shorter hue, var(--c-grey-500), black 8%);
}

.btn-neutral-nofill {
    display: grid;
    align-items: center;
    padding: 6px 12px;
    background-color: color-mix(in hsl shorter hue, var(--c-fg-primary), black 8%);
}

.btn-neutral-nofill:hover {
    background-color: var(--c-fg-primary);
}

.btn-danger {
    background-color: var(--c-danger-red);
    color: var(--c-grey-700);
    font-weight: 500;
}

.btn-danger:hover {
    background-color: color-mix(in hsl shorter hue, var(--c-danger-red), black 8%);
}

.btn-danger-nofill {
    display: grid;
    align-items: center;
    padding: 2px 12px;
    border: 1px solid var(--c-danger-red);
}

.btn-danger-nofill:hover {
    background-color: var(--c-bg-secondary);
}

.plus-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid var(--c-grey-500);
    transition: transform 0.1s ease;
    font-size: 0.8125rem;
}

.plus-btn:hover {
    background-color: var(--c-bg-secondary);
}

#quick-add-btn:hover {
    background-color: color-mix(in hsl shorter hue, var(--c-bg-secondary), white 1.1%);
}

.plus-btn:active {
    transform: scale(0.99);
}

.plus-icon,
.trash-icon,
.x-icon,
.menu-icon {
    width: 20px;
    height: 20px;
    color: var(--c-grey-300);
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
}

.x-icon {
    color: var(--c-grey-100);
}

.trash-icon {
    color: color-mix(in hsl shorter hue, var(--c-danger-red), black 20%);
}


/* MEDIA QUERIES
====================================================== */

@media (width <= 1656px) {
    .form-row {
        flex-direction: column;
    }
}

@media (width <= 1656px) {
    .form-row {
        flex-direction: column;
    }
}

@media (width <= 1360px) {
    .topbar {
        display: flex;
    }

    .sidebar {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        z-index: 5;
        transform: translateX(-100%);
        transition: transform 0.2s ease;
    }

    .sidebar.open {
        transform: translateX(0);
    }

    main {
        grid-column: 1 / span 2;
    }
}

@media (width <= 1260px) {
    .task-form {
        position: absolute;
        top: 0;
        right: 0;
        transform: translateX(100%);
        transition: transform 0.2s ease;
    }

    .task-form.open {
        transform: translateX(0);
    }

    main {
        grid-column: 1 / span 3;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B;;mEAE0D;IAC1D,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;wDACwD;;AAExD;IACI,gCAAgC;;IAEhC,gCAAgC;IAChC,qCAAqC;IACrC,kCAAkC;IAClC,mCAAmC;;IAEnC,2BAA2B,EAAE,eAAe;IAC5C,2BAA2B,EAAE,QAAQ;IACrC,2BAA2B,EAAE,QAAQ;IACrC,2BAA2B,EAAE,eAAe;IAC5C,2BAA2B,EAAE,SAAS;IACtC,2BAA2B,EAAE,YAAY;IACzC,2BAA2B,EAAE,YAAY;;;IAGzC,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;;;IAG/B,mCAAmC;IACnC,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;wDACwD;;AAExD;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,YAAY;AAChB;;AAEA;wDACwD;;AAExD;IACI,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,oDAAoD;IACpD;wBACoB;AACxB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;wDACwD;;AAExD;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,6EAA6E;AACjF;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;wDACwD;;AAExD;IACI,cAAc;IACd,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;AACd;;AAEA;wDACwD;;AAExD;IACI,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;wDACwD;;AAExD;IACI,aAAa;IACb,4DAA4D;IAC5D,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,gEAAgE;AACpE;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mCAAmC;IACnC,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;;AAGA;wDACwD;;AAExD;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,uCAAuC;IACvC,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;wDACwD;;AAExD;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,oBAAoB;IACpB,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;wDACwD;;AAExD;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,iCAAiC,EAAE,6CAA6C;IAChF,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,sBAAsB,2BAA2B,EAAE;AACnD,yBAAyB,6BAA6B,EAAE;AACxD,uBAAuB,0BAA0B,EAAE;;;AAGnD;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,gEAAgE;AACpE;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mCAAmC;IACnC,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,0CAA0C;IAC1C,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;wDACwD;;AAExD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8EAA8E;AAClF;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,8EAA8E;AAClF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kFAAkF;AACtF;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;IAII,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oEAAoE;AACxE;;;AAGA;wDACwD;;AAExD;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,UAAU;QACV,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,2BAA2B;QAC3B,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["@font-face {\n    font-family: \"Inter Variable\";\n    src: url(\"./assets/Inter-Variable.woff2\") format(\"woff2-variations\"),\n         url(\"./assets/Inter-Variable.woff\") format(\"woff-variations\"),\n         url(\"./assets/Inter-Variable.ttf\") format(\"truetype\");\n    font-weight: 100 900;\n    font-stretch: 50% 150%;\n    font-display: swap;\n}\n\n/* VARIABLES\n====================================================== */\n\n:root { \n    --c-danger-red: hsl(357 53% 60%);\n\n    --c-accent-red: hsl(4, 85%, 63%);\n    --c-accent-orange: hsl(40, 100%, 49%);\n    --c-accent-lime: hsl(84, 54%, 46%);\n    --c-accent-blue: hsl(216, 81%, 60%); \n\n    --c-grey-100: hsl(0 4% 88%); /* 13.1 E2DFDF*/\n    --c-grey-200: hsl(0 4% 77%); /* 9.9 */\n    --c-grey-300: hsl(0 4% 64%); /* 6.4 */\n    --c-grey-400: hsl(0 2% 52%); /* 4.6 #878282*/\n    --c-grey-500: hsl(0 2% 40%); /* 2.97 */\n    --c-grey-600: hsl(0 2% 26%); /* #444141 */\n    --c-grey-700: hsl(0 2% 18%); /* #444141 */\n\n\n    --c-bg-primary: hsl(0 0% 7%);\n    --c-bg-secondary: hsl(0 0% 9%);\n    --c-fg-primary: hsl(0 2% 11%);\n    --c-fg-secondary: hsl(0 2% 13%);\n\n\n    --c-text-default: var(--c-grey-100);\n    --c-text-muted: var(--c-grey-200);\n    --c-text-faint: var(--c-grey-500);\n}\n\n/* NORMALISE\n====================================================== */\n\n*, *:before, *:after {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    max-width: 100%;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\nul, ol, li {\n    list-style: none;\n}\n\ninput, textarea, button, select {\n    font: inherit;\n    color: inherit;\n    background: none;\n    border: none;\n}\n\nbutton {\n    cursor: pointer;\n}\n\nhr {\n    border: none;\n}\n\ndialog {\n    font: inherit;\n    color: inherit;\n    border: none;\n}\n\n/* BASE\n====================================================== */\n\nhtml, body {\n    height: 100%;\n    font-family: \"Inter Variable\";\n    font-weight: 350;\n    color: var(--c-text-default);\n    background-color: var(--c-bg-primary);\n}\n\n.shell {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n}\n\n.container {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    position: relative;\n    display: grid;\n    grid-template-columns: 0.65fr 3fr minmax(328px, 1fr);\n    grid-template-areas: \n    \"sidebar tasks form\";\n}\n\ndialog {\n    background-color: var(--c-bg-secondary);\n}\n\n/* SIDEBAR\n====================================================== */\n\n.sidebar {\n    grid-area: sidebar;\n    min-width: 200px;\n    display: grid;\n    grid-auto-rows: min-content;\n    gap: 40px;\n    padding: 20px 20px;\n    border-right: 1px solid var(--c-grey-700);\n    background-color: var(--c-bg-primary);\n}\n\nul {\n    display: grid;\n    gap: 4px; \n}\n\n.sidebar-item {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    font-size: 0.875rem;\n    color: var(--c-text-muted);\n}\n\n.sidebar-item:hover,\n.sidebar-item:has(.sidebar-more-btn.menu-open):not(.active) {\n    border-radius: 6px;\n    background-color: var(--c-fg-primary);\n    cursor: pointer;\n}\n\n.sidebar-item.active {\n    border-radius: 6px;\n    background-color: var(--c-grey-600);\n    color: var(--c-grey-100);\n}\n\n.sidebar-icon {\n    flex-shrink: 0;\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    stroke-width: 1.5;\n    color: var(--c-grey-400);\n}\n\n.sidebar-projects {\n    display: grid;\n    gap: 12px;\n}\n\n.sidebar-projects h3 {\n    font-size: 0.8125rem;\n    color: var(--c-text-faint);\n}\n\n.sidebar-label {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sidebar-end-slot{\n    margin-left: auto;\n    display: grid;\n    grid-template-areas: \"stack\";\n    align-items: center;\n    justify-items: center;\n    min-width: 20px;\n}\n\n.sidebar-count,\n.sidebar-more-btn {\n    grid-area: stack;\n}\n\n.sidebar-count {\n    font-size: 0.75rem;\n    color: var(--c-grey-200);\n}\n\n.sidebar-more-btn {\n    opacity: 0;\n    padding: 2px 8px;\n    border-radius: 4px;\n}\n\n.sidebar-item:has(.sidebar-more-btn):hover .sidebar-count,\n.sidebar-item:has(.sidebar-more-btn.menu-open) .sidebar-count {\n    opacity: 0;\n}\n\n.sidebar-item:hover .sidebar-more-btn,\n.sidebar-more-btn.menu-open {\n    opacity: 1;\n}\n\n.sidebar-more-btn:hover,\n.sidebar-more-btn.menu-open {\n    background-color: color-mix(in hsl shorter hue, var(--c-grey-600), black 12%);\n}\n\n.context-menu {\n    position: fixed;\n    background: var(--c-fg-secondary);\n    padding: 4px;\n    border-radius: 6px;\n    list-style: none;\n    z-index: 1000;\n}\n\n.context-menu.hidden {\n    display: none;\n}\n\n.context-menu button {\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 0.8125rem;\n}\n\n.context-menu button:hover {\n    background: var(--c-grey-600);\n}\n\n/* TOPBAR (sidebar toggle)\n====================================================== */\n\n.topbar {\n    flex-shrink: 0;\n    display: none;\n    width: 100%;\n    padding: 14px 20px;\n    border-bottom: 1px solid var(--c-grey-700);\n    background-color: var(--c-bg-primary);\n}\n\n.sidebar-toggle-btn {\n    display: flex;\n    align-items: center;\n    padding: 4px;\n}\n\n.sidebar-toggle-btn:hover {\n    background-color: var(--c-grey-700);\n}\n\n.menu-icon {\n    width: 24px;\n    height: 24px;\n    color: var(--c-grey-100);\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    fill: none;\n}\n\n/* MAIN\n====================================================== */\n\nmain {\n    grid-area: tasks;\n    display: grid;\n    grid-template-rows: auto 1fr;\n    gap: 20px;\n    padding: 20px 20px;\n    background-color: var(--c-bg-secondary);\n}\n\nmain header {\n    display: grid;\n    grid-template: auto auto / 1fr auto;\n    gap: 8px;\n}\n\nmain header h1 {\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    font-size: 26px;\n    font-weight: 500;\n\n}\nmain header p {\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-height: 1.5;\n    min-height: calc(1.5em * 3);\n    color: var(--c-grey-400);\n}\n\nmain header button {\n    grid-column: 2;\n    grid-row: 1;\n    width: 96px;\n    white-space: nowrap;\n}\n\n.task-list-section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.task-list-header {\n    display: grid;\n    grid-template: auto / 0.06fr 1fr 0.35fr 0.21fr 0.17fr 0.2fr;\n    gap: 20px;\n    padding-bottom: 4px;\n    border-bottom: 1px solid var(--c-grey-600);\n    font-size: 0.875rem;\n    color: var(--c-grey-400);\n}\n\n.header-checkbox {\n    justify-self: center;\n    width: 20px;\n    height: 20px;\n    margin-left: 10px;\n}\n\n.header-project {\n    visibility: visible;\n}\n\n.task-list-header:not(.show-project) .header-project {\n    visibility: hidden;\n}\n\n/* TASKS LIST\n====================================================== */\n\n.card-task {\n    display: grid;\n    grid-template-columns: 0.06fr 1fr 0.35fr 0.21fr 0.17fr 0.2fr;\n    align-items: center;\n    gap: 20px;\n    min-width: 600px;\n    padding: 14px 0px;\n    border-bottom: 1px solid var(--c-grey-700);\n}\n\n.card-task:hover {\n    background-color: var(--c-fg-primary);\n    cursor: pointer;\n}\n\n.task-checkbox {\n    justify-self: center;\n    position: relative;\n    box-sizing: border-box;\n    appearance: none;\n    margin-left: 10px;\n    padding: 0;\n    width: 20px;\n    height: 20px;\n    border: 1px solid var(--c-grey-400);\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.task-checkbox:hover {\n    border-color: var(--c-grey-300);\n}\n\n.task-checkbox:checked {\n    background-color: var(--c-accent-lime);\n    border-color: var(--c-accent-lime);\n}\n\n.task-checkbox:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 5px;\n    top: 1px;\n    width: 8px;\n    height: 12px;\n    border: 1px solid var(--c-grey-600);\n    border-width: 0px 2px 2px 0px;\n    transform: rotate(45deg);\n}\n\n.card-task h2 {\n    overflow-wrap: break-word;\n    min-width: 0;\n    hyphens: auto;\n    padding: 4px 0px;\n    font-size: 1rem;\n    font-weight: 350;\n    line-height: 1.6;\n}\n\n.card-task h2.done {\n    text-decoration: line-through;\n    color: var(--c-grey-400);\n}\n\n.card-task span {\n    font-size: 0.875rem;\n    color: var(--c-grey-400);\n}\n\n.hidden-tag {\n    visibility: hidden;\n}\n\n.card-task span[data-priority=\"low\"] {\n    color: var(--c-accent-lime);\n}\n\n.card-task span[data-priority=\"medium\"] {\n    color: var(--c-accent-orange);\n}\n\n.card-task span[data-priority=\"high\"] {\n    color: var(--c-accent-red); \n}\n\n.card-task span[data-status=\"overdue\"] {\n    color: var(--c-accent-red); \n}\n\n.card-task span[data-status=\"today\"] {\n    color: var(--c-accent-orange);\n}\n\n.card-task span[data-status=\"soon\"] {\n    color: var(--c-accent-blue); \n}\n\n.quick-add {\n    display: grid;\n}\n\n.card-task.selected {\n  background: var(--c-grey-700);\n  border-radius: 6px;\n}\n\n\n/* MODALS/FORMS/INPUTS GENERAL\n====================================================== */\n\n.modal {\n    position: fixed;\n    margin: auto;\n    border-radius: 20px;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.modal::backdrop {\n    background-color: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(0.3px);\n}\n\n.form-modal,\n.delete-modal {\n    width: 400px;\n    padding: 20px;\n    background-color: var(--c-fg-primary)\n}\n\n.form-wrapper,\n.modal-wrapper {\n    display: grid;\n    gap: 16px;\n}\n\nh2 {\n    font-size: 1rem;\n}\n\nlabel {\n    font-size: 0.875rem;\n    color: var(--c-grey-400);\n}\n\n.form-content {\n    display: grid;\n    flex: 1;\n    gap: 6px;\n}\n\ninput, textarea, select {\n    appearance: base-select;\n    padding: 6px 10px;\n    border: 1px solid var(--c-grey-700);\n    border-radius: 6px;\n    background-color: var(--c-fg-secondary);\n    transition: border 0.15s ease-in-out;\n    font-weight: 300;\n}\n\ntextarea {\n    resize: vertical;\n    min-height: 60px;\n    field-sizing: content;\n    overflow-y: auto;\n}\n\n#edit-task-title {\n    resize: none;\n    min-height: auto;\n}\n\ntextarea::placeholder {\n    color: var(--c-grey-600);\n}\n\ninput:hover, textarea:hover, select:hover {\n    border: 1px solid var(--c-grey-600);\n}\n\ninput:focus, textarea:focus, select:focus {\n    outline: none;\n    border: 1px solid var(--c-grey-500)\n}\n\n.form-actions,\n.modal-actions {\n    display: flex;\n    justify-content: end;\n    gap: 12px;\n    margin-top: 28px;\n}\n\n.task-title-input {\n    min-width: 400px;\n    min-height: auto;\n}\n\n\n/* PROJECTFORM\n====================================================== */\n\n.color-picker {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 4px;\n}\n\n.color-swatch {\n    width: 20px;\n    height: 20px;\n    border-radius: 2px;\n    outline: 3px solid var(--c-grey-600);\n    outline-offset: -5px;\n    outline-color: transparent;\n    transition: outline-color 0.15s ease;\n}\n\n.color-swatch.selected {\n    outline-color: var(--c-grey-600);\n}\n\n/* TASKFORM (+ASIDE)\n====================================================== */\n\n.task-form {\n    grid-area: form;\n    height: 100%;\n    padding: 20px 20px;\n    border-left: 1px solid var(--c-grey-700);\n    background-color: var(--c-bg-primary);\n}\n\n.hidden {\n    display: none;\n}\n\n.form-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.form-row {\n    display: flex;\n    gap: 12px;\n}\n\n#task-due,\n#edit-task-due {\n    padding-right: 6px;\n}\n\n#task-due::-webkit-calendar-picker-indicator,\n#edit-task-due::-webkit-calendar-picker-indicator {\n    filter: invert(1) brightness(0.7); /* slightly softened white, adjust to taste */\n    cursor: pointer;\n}\n\nselect[data-priority=\"low\"] {   \n    color: var(--c-accent-lime);\n}\n\nselect[data-priority=\"medium\"] { \n    color: var(--c-accent-orange);\n}\n\nselect[data-priority=\"high\"] { \n    color: var(--c-accent-red); \n}\n\noption[value=\"low\"] { color: var(--c-accent-lime); }\noption[value=\"medium\"] { color: var(--c-accent-orange); }\noption[value=\"high\"] { color: var(--c-accent-red); }\n\n\n.checklist-items {\n    display: grid;\n    gap: 4px;\n    padding: 0px 6px;\n    margin-bottom: 8px;\n}\n\n.checklist-item {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    gap: 6px;\n    align-items: center;\n}\n\n.checklist-item-checkbox {\n    justify-self: center;\n    position: relative;\n    box-sizing: border-box;\n    appearance: none;\n    padding: 0;\n    width: 16px;\n    height: 16px;\n    border: 1px solid var(--c-grey-400);\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.checklist-item-checkbox:hover {\n    border-color: var(--c-grey-300);\n}\n\n.checklist-item-checkbox:checked {\n    background-color: var(--c-accent-lime);\n    border-color: var(--c-accent-lime);\n}\n\n.checklist-item-checkbox:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 4.5px;\n    top: 1px;\n    width: 6px;\n    height: 10px;\n    border: 1px solid var(--c-grey-600);\n    border-width: 0px 2px 2px 0px;\n    transform: rotate(45deg);\n}\n\n.checklist-item-text {\n    border: none;\n    border-bottom: 1px solid var(--c-grey-700);\n    border-radius: 0;\n    background-color: transparent;\n}\n\n.checklist-item-text.done {\n    text-decoration: line-through;\n    color: var(--c-grey-400);\n}\n\n.checklist-item-text:hover {\n    border: none;\n    border-bottom: 1px solid var(--c-grey-600);\n}\n\n.checklist-item-text:focus {\n    outline: none;\n    border: none;\n    border-bottom: 1px solid var(--c-grey-500)\n}\n\n.checklist-item-text::placeholder {\n    color: var(--c-grey-500);\n}\n\n.form-sidebar .form-actions {\n    margin-top: 40px;\n}\n\n#edit-task-delete {\n    margin-right: auto;\n}\n\n/* ACTION BUTTONS \n====================================================== */\n\n.btn {\n    padding: 8px 12px;\n    border-radius: 4px;\n    font-size: 0.875rem;\n    transition: transform 0.15s ease;\n}\n\n.btn:active {\n    transform: scale(0.97);\n}\n\n.btn-primary {\n    background-color: var(--c-grey-100);\n    color: var(--c-grey-600);\n    font-weight: 500;\n}\n\n.btn-primary:hover {\n    background-color: color-mix(in hsl shorter hue, var(--c-grey-100), black 8%);;\n}\n\n.btn-primary.color {\n    background-color: var(--c-accent-lime);\n}\n\n.btn-primary.color:hover {\n    background-color: color-mix(in hsl shorter hue, var(--c-accent-lime), black 8%);\n}\n\n.btn-neutral {\n    background-color: var(--c-grey-500);\n    color: var(--c-grey-100);\n}\n\n.btn-neutral:hover {\n    background-color: color-mix(in hsl shorter hue, var(--c-grey-500), black 8%);\n}\n\n.btn-neutral-nofill {\n    display: grid;\n    align-items: center;\n    padding: 6px 12px;\n    background-color: color-mix(in hsl shorter hue, var(--c-fg-primary), black 8%);\n}\n\n.btn-neutral-nofill:hover {\n    background-color: var(--c-fg-primary);\n}\n\n.btn-danger {\n    background-color: var(--c-danger-red);\n    color: var(--c-grey-700);\n    font-weight: 500;\n}\n\n.btn-danger:hover {\n    background-color: color-mix(in hsl shorter hue, var(--c-danger-red), black 8%);\n}\n\n.btn-danger-nofill {\n    display: grid;\n    align-items: center;\n    padding: 2px 12px;\n    border: 1px solid var(--c-danger-red);\n}\n\n.btn-danger-nofill:hover {\n    background-color: var(--c-bg-secondary);\n}\n\n.plus-btn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n    border-radius: 6px;\n    border: 1px solid var(--c-grey-500);\n    transition: transform 0.1s ease;\n    font-size: 0.8125rem;\n}\n\n.plus-btn:hover {\n    background-color: var(--c-bg-secondary);\n}\n\n#quick-add-btn:hover {\n    background-color: color-mix(in hsl shorter hue, var(--c-bg-secondary), white 1.1%);\n}\n\n.plus-btn:active {\n    transform: scale(0.99);\n}\n\n.plus-icon,\n.trash-icon,\n.x-icon,\n.menu-icon {\n    width: 20px;\n    height: 20px;\n    color: var(--c-grey-300);\n    stroke-width: 1.5;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    fill: none;\n}\n\n.x-icon {\n    color: var(--c-grey-100);\n}\n\n.trash-icon {\n    color: color-mix(in hsl shorter hue, var(--c-danger-red), black 20%);\n}\n\n\n/* MEDIA QUERIES\n====================================================== */\n\n@media (width <= 1656px) {\n    .form-row {\n        flex-direction: column;\n    }\n}\n\n@media (width <= 1656px) {\n    .form-row {\n        flex-direction: column;\n    }\n}\n\n@media (width <= 1360px) {\n    .topbar {\n        display: flex;\n    }\n\n    .sidebar {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        z-index: 5;\n        transform: translateX(-100%);\n        transition: transform 0.2s ease;\n    }\n\n    .sidebar.open {\n        transform: translateX(0);\n    }\n\n    main {\n        grid-column: 1 / span 2;\n    }\n}\n\n@media (width <= 1260px) {\n    .task-form {\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translateX(100%);\n        transition: transform 0.2s ease;\n    }\n\n    .task-form.open {\n        transform: translateX(0);\n    }\n\n    main {\n        grid-column: 1 / span 3;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
